module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAICAYAAADwdn+XAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAB9SURBVHgBnZCxCYAwEEV/wAFsItg5mm7gBuoITqCbOE6SSxFrBc+ksBFMgh+u+fDeHQckYq0dwuBPiGgxhjjMl6SIwcxorwsdwI2vRi+BlHJC7malqH06pcwYuyQKZ0ticFKSA78lWutehMI5Vx7HufmHzXVdrchIkAjB+w23JIJpnZ7E6QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/up.png
// module id = WY0H
// module chunks = 1